<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QwAYlA/tc-custom/9781504028189.jpg?1698091966963" alt="This image is the cover for the book Murder Times Two, The Reuben Frost Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Times Two, The Reuben Frost Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The murder of an eccentric millionaire presents a deadly puzzle for Reuben Frost</b><br/>  <br/> When Tobias Vandermeer, heir to one of New York’s great real estate fortunes, required a quiet divorce, there was no lawyer more equipped than Reuben Frost. A cheerful drunk with a knack for jazz piano, Vandermeer and Frost remained friends—right up until the day the former drops dead in the midst of a reading club dinner. The poison found in his bloodstream makes Vandermeer’s death a murder; his fabulous wealth makes it a scandal.<br/>  <br/> Frost senses a clue in the deceased’s latest needlepoint effort: a scene from the devastating satire <i>Vanity Fair</i>, the book club’s latest subject. But eliminating suspects and finding his old friend’s killer will require an angry call to the mayor, a trip to Rio, and at least one more death.<br/>  <br/><i>Murder Times Two</i> is the 5th book in the Reuben Frost Mysteries, but you may enjoy reading the series in any order.<br/>  <br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Haughton Murphy
      </h2>
      
      <p class="authorDescription body article">Haughton Murphy is the pseudonym of former lawyer James H. Duffy, author of the Reuben Frost Mysteries. A graduate of Princeton University and Harvard Law School, Duffy got his start writing as a part-time and summer reporter for the <I>Daily Times</I> of Watertown, New York, before moving to New York City to practice law. After a number of years as an attorney, Duffy began writing thrillers, eventually retiring to focus on his novels full-time.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15e1a91c